import { useState } from "react";
import { useSelector } from "react-redux";
import { getTickets } from "../../../Actions/HelpAction";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const TicketingButton = props => {
    
    const Dictionary = useSelector(state => state.VisualData.Dictionary);
    
    const [loading,setLoading] = useState(false);
    
    const token = localStorage.getItem("userToken");

    const fetchData = async (params) => {        
        setLoading(true);
        const response = await getTickets(params);
        
        if(response.data?.result?.items?.length){
            props.history.push(`/profile?mode=tickets&reserveId=${props.reserveId}`)
        }else{
            props.history.push(`/tickets/create?reserveId=${props.reserveId}`)
        }

        setLoading(false);
    }


    const clickHandler = () => {
        if (token && props.reserveId) {
            const parameters = {
                token: token,
                MaxResultCount: 10,
                SkipCount: 0,
                ReserveId: props.reserveId
            }
            fetchData(parameters);
        }
    }

    return(
        <button
            type="button"
            className={`support-btn button ${props.className || "blue-btn"}`}
            onClick={clickHandler}
        >
            {Dictionary.SupportTicket} 
            {loading? <span className="loading-inline-circle xsmall" /> : null}
        </button>
    )
}

export default withRouter(TicketingButton);